import React from 'react';

import { Select } from '@aline/common';
import { link } from '@aline/routes';
import { matchPath, useLocation, useNavigate } from 'react-router-dom';
import {
  communityTemplatePaths,
  communityWorkflowPaths,
} from 'src/components/community/pages/CommunityPage';
import { AlineTabs } from 'src/components/generic/AlineTabs';
import { useMaybeCommunityParams } from 'src/helpers';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  tabs: {
    flex: '0 0 auto',
    marginBottom: theme.spacing(2),
  },
}));

enum CommunityTabValue {
  Templates,
  Workflows,
}

export function CommunityTabs(): JSX.Element {
  const { classes } = useStyles();
  const navigate = useNavigate();
  const location = useLocation();
  const { categoryId } = useMaybeCommunityParams();
  const isAtCommunityTemplates = Boolean(
    communityTemplatePaths.some(path => matchPath({ end: false, path }, location.pathname))
  );
  const isAtCommunityWorkflows = Boolean(
    communityWorkflowPaths.some(path => matchPath({ end: false, path }, location.pathname))
  );
  const value = isAtCommunityTemplates
    ? CommunityTabValue.Templates
    : isAtCommunityWorkflows
      ? CommunityTabValue.Workflows
      : null;

  return (
    <AlineTabs<CommunityTabValue>
      tabs={[
        {
          dataCy: Select.community.index.documentsTab,
          label: 'Templates',
          value: CommunityTabValue.Templates,
        },
        {
          dataCy: Select.community.index.workflowsTab,
          label: 'Workflows',
          value: CommunityTabValue.Workflows,
        },
      ]}
      tabsProps={{ classes: { root: classes.tabs } }}
      value={value}
      onChange={value => {
        switch (value) {
          case CommunityTabValue.Templates: {
            const route = categoryId
              ? link.CommunityCategoryDocuments({ categoryId })
              : link.CommunityDocumentIndex();
            return navigate(route);
          }
          case CommunityTabValue.Workflows: {
            const route = categoryId
              ? link.CommunityCategoryWorkflows({ categoryId })
              : link.CommunityWorkflowIndex();
            return navigate(route);
          }
        }
      }}
    />
  );
}
